import { Message, MessageBox } from "element-ui";
import { request } from "./ajaxProxy.js";
import StringUtil from "./StringUtil.js";
var MGridUtil = {
  //日期截断为YYYY-MM-DD
  dateFormatYYMMDD: function(type, time) {
    if (time != null) {
      return time.substr(0, 10);
    } else {
      return "";
    }
  },
  toFixedTwo(n, decimals) {
    let num = decimals != null ? decimals : 2;
    return Number(`${Math.round(`${n}e${num}`)}e-${num}`);
  },
  /**
   * 格式化时间
   * fmt 时间格式 例如:yyyy-MM-dd hh:mm:ss
   * time 时间
   */
  getTime: function(fmt, time) {
    if (time != undefined) {
      var date = new Date(time);
      var o = {
        "M+": date.getMonth() + 1, //月份
        "d+": date.getDate(), //日
        "h+": date.getHours(), //小时
        "m+": date.getMinutes(), //分
        "s+": date.getSeconds(), //秒
        "q+": Math.floor((date.getMonth() + 3) / 3), //季度
        S: date.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(
          RegExp.$1,
          (date.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return fmt;
    }
  },
  /**
   * 字符串转时间
   * @param str
   * @param dayNumber 要加的天数
   * @returns {Date}
   */
  getDate(str, dayNumber) {
    str = str.replace(/-/g, "/");
    str = str.replace(/(\.\d+)?/g, "");
    if (dayNumber != null) {
      str = new Date(str).getTime() + dayNumber * 24 * 60 * 60 * 1000;
    }
    return new Date(str);
  },
  // 只能输入数字和小数点
  keepNumOrDecimal(num) {
    //先把非数字的都替换掉，除了数字和小数点
    num = num.replace(/[^\d.]/g, "");
    //必须保证第一个为数字而不是.
    num = num.replace(/^\./g, "");
    //保证只有出现一个.而没有多个.
    num = num.replace(/\.{2,}/g, ".");
    //保证.只出现一次，而不能出现两次以上
    num = num
      .replace(".", "$#$")
      .replace(/\./g, "")
      .replace("$#$", ".");
    num = num.replace(/([0-9]+\.[0-9]{2})[0-9]*/, "$1");
    // getScope().$apply("clinicObj");
    return num;
  },
  //获取当天
  getNowDate() {
    let startTime = new Date(
        new Date(new Date().getTime() - 60 * 60 * 1000).setHours(0, 0, 0, 0)
      ),
      endTime = new Date(
        new Date(new Date().getTime() - 60 * 60 * 1000).setHours(
          23,
          59,
          59,
          999
        )
      );
    return [startTime, endTime];
  },
  //获取自然月
  getNowMonth(){
    let startTime = new Date(
      new Date(new Date().setDate(1)).toLocaleDateString()
      ),
      endTime = new Date(
        new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
      );
    return [startTime, endTime];
  },
  // 获取当前时间
  getNowFormatDate: function() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    var currentdate =
      year +
      seperator1 +
      month +
      seperator1 +
      strDate +
      " " +
      hours +
      ":" +
      minutes +
      ":" +
      seconds;
    return currentdate;
  },
  // 获取当前时分秒
  getNowFormatDateHMS: function() {
    var arr = [];
    var date = new Date();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    var currentdate = hours + ":" + minutes + ":" + seconds + "-" + "23:59:59";
    arr.push(currentdate);
    return arr;
  },
  // 设置表格头部必填
  customFieldColumn: function(h, { column, $index }) {
    return h("span", {}, [
      h("span", {}, ""),
      h("el-popover", {}, [
        h(
          "span",
          {
            slot: "reference"
          },
          [
            h(
              "span",
              {
                style: "color:red"
              },
              "* "
            ),
            h("span", {}, column.label)
          ]
        )
      ])
    ]);
  },
  // 设置表格头部专管药标红
  customFieldSpecial: function(h, { column }) {
    return h("span", [
      h("span", column.label),
      h(
        "span",
        {
          style: "color:#FF0000"
        },
        "(专管药标红) "
      )
    ]);
  },
  // 设置表格头部提示
  customFieldTips: function(h, { column }) {
    // return h(
    //     'div', [
    //     h('span'), column.label),
    //     h('el-tooltip', {
    //         props: {
    //             effect: 'dark',
    //             content: '小时统计该时段整体数据，如当小时为09:00时，那统计的就是',
    //             placement: 'top',
    //         },
    //     },
    //         [h('i', {
    //             class: 'el-icon-question',
    //             style: 'color:#409eff;margin-left:5px;cursor:pointer;'
    //         })],
    //         { content: '小时统计该时段整体数据' })
    // ]);
  },
  // 设置表格头部为空
  customFieldNull: function(h, { column, $index }) {
    return h("span", {}, [
      h("span", {}, ""),
      h("el-popover", {}, [
        h(
          "span",
          {
            slot: "reference"
          },
          [h("span", {}, "")]
        )
      ])
    ]);
  },
  //Message提示弹窗
  MessageShow: function(msg, type) {
    bus.$message({
      message: msg,
      type: type
    });
  },
  //Message确认弹窗
  MessageBox: function(title, Edit, isCenter) {
    return new Promise(function(resolve, reject) {
      bus
        .$confirm(title, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: isCenter ? true : false
        })
        .then(() => {
          resolve();
        })
        .catch(() => {
          reject();
        });
    })
      .then(() => {
        Edit();
      })
      .catch(() => {});
  },
  /**
   *@method:parseTime
   *@description:时间
   *@param:time cFormat
   **/
  parseTime(time, cFormat) {
    if (arguments.length === 0) {
      return null;
    }
    const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
    let date;
    if (typeof time === "object") {
      date = time;
    } else {
      if (("" + time).length === 10) time = parseInt(time) * 1000;
      date = new Date(time);
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate() + 1,
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key];
      if (key === "a")
        return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
      if (result.length > 0 && value < 10) {
        value = "0" + value;
      }
      return value || 0;
    });
    return time_str;
  },
  /**
   *@method:uniqueFun
   *@description:数据去重
   *@param:arr type:唯一标识
   **/
  uniqueFun(arr, type) {
    const res = new Map();
    return arr.filter(a => !res.has(a[type]) && res.set(a[type], 1));
  },
  // 获取当前日期
  getNowTime: function() {
    var date = new Date();
    var seperator1 = "-";
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var strDate = date.getDate();
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
    }
    if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
    }
    if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
    }
    var currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getAftermonth(second){
    var nowdate = new Date();
    var y = nowdate.getFullYear();
    var m = nowdate.getMonth() + 1;
    if (m >= 1 && m <= 9) {
      m = "0" + m;
    }
    var d = nowdate.getDate();
    if (d >= 0 && d <= 9) {
      d = "0" + d;
    }
    
    if (second){
      var formatnowdate = y + "-" + m + "-" + d + ' ' + '23:59:59';
    } else {
      var formatnowdate = y + "-" + m + "-" + d ;
    }
    //获取系统前一个月的时间
    nowdate.setMonth(nowdate.getMonth() - 1);
    var y = nowdate.getFullYear();
    var m = nowdate.getMonth() + 1;
    if (m >= 1 && m <= 9) {
      m = "0" + m;
    }
    var d = nowdate.getDate();
    if (d >= 0 && d <= 9) {
      d = "0" + d;
    }
    if (second){
      var formatwdate = y + "-" + m + "-" + d + ' ' + '00:00:00';
    } else {
      var formatwdate = y + "-" + m + "-" + d ;
    }
    
    let arr = [];
    arr[1] = formatnowdate;
    arr[0] = formatwdate;
    return arr;
  }
};
export default MGridUtil;



// WEBPACK FOOTER //
// ./src/utils/MGridUtil.js